import React, { useState } from "react";
import cn from "classnames";
import { TextLink, TextLinkTheme, Typography } from "@trussle/external-components";
import { AccordionVariant, IAccordionItemMobile } from "../../types/IAccordionItem";
import "./styles.scss";
import PurchaseSVG from "./purchase.svg";
import RemortgageSVG from "./remortgage.svg";
import InsuranceSVG from "./insurance.svg";

export interface IAccordionMobile {
    accordion: IAccordionItemMobile[];
    accordionSecondary?: IAccordionItemMobile[];
    firstTabVariant?: AccordionVariant;
    secondTabVariant?: AccordionVariant;
    accordionTitle?: string;
    accordionTitleSecondary?: string;
    title?: string;
    titleSecondary?: string;
}

export const GetVariantIcon: React.FC<{variant?: string}> = ({ variant }) => (variant === "orange" ? (
  <img src={PurchaseSVG} alt="title-icon" loading="lazy" />
) : variant === "green" ? (
  <img src={RemortgageSVG} alt="title-icon" loading="lazy" />
) : (
  <img src={InsuranceSVG} alt="title-icon" loading="lazy" />
));

const AccordionItemMobile: React.FC<IAccordionItemMobile> = ({
  title,
  secondaryTitle,
  content,
  isOpen,
  onClick,
  step,
  variant,
}) => (
  <div className={cn("accordion-item-mobile", { open: isOpen })}>
    <div className="accordion-item-mobile-header">
      <GetVariantIcon variant={variant} />
      {secondaryTitle}
    </div>
    <button className="accordion-item-mobile-title" onClick={onClick} type="button">
      <span>{step}</span>
      <span>{title}</span>
    </button>
    <div className="accordion-item-mobile-content" data-testid={`accordion-item-mobile-content-${title}`}>
      {content}
    </div>
  </div>
);

const AccordionMobile: React.FC<IAccordionMobile> = ({
  title,
  titleSecondary,
  accordion,
  accordionSecondary,
  firstTabVariant,
  secondTabVariant,
  accordionTitle,
  accordionTitleSecondary,
}) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [activeTab, setActiveTab] = useState<AccordionVariant | undefined>(firstTabVariant);
  const handleClick = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const handleTabClick = (tab: AccordionVariant | undefined) => {
    setActiveTab(tab);
  };
  return (
    <div className="accordion-mobile__container">
      {(title && titleSecondary)
        ? (
          <Typography variant="h2" classes="section-title" component="p" id="accordion-mobile-section-title">
            {activeTab === firstTabVariant ? title : titleSecondary}
          </Typography>
        )
        : <Typography variant="h2" classes="section-title" component="p" id="accordion-mobile-section-title">{title}</Typography>}
      {(accordionTitle && accordionTitleSecondary) && (
        <div className="accordion-tab">
          <TextLink
            onClick={() => handleTabClick(firstTabVariant)}
            theme={TextLinkTheme.SECONDARY}
            className={cn("accordion-tab-button", firstTabVariant, { active: activeTab === firstTabVariant })}
          >
            {accordionTitle}
          </TextLink>
          <TextLink
            onClick={() => handleTabClick(secondTabVariant)}
            theme={TextLinkTheme.SECONDARY}
            className={cn("accordion-tab-button", secondTabVariant, { active: activeTab === secondTabVariant })}
          >
            {accordionTitleSecondary}
          </TextLink>
        </div>
      )}
      {(accordionTitle && accordionTitleSecondary)
        ? activeTab === firstTabVariant
          ? (
            <div className={cn("accordion-mobile", firstTabVariant)}>
              {accordion.map((item, index) => (
                <AccordionItemMobile
                  key={index}
                  step={index + 1}
                  title={item.title}
                  variant={firstTabVariant}
                  secondaryTitle={item.secondaryTitle}
                  content={item.content}
                  isOpen={openIndex === index}
                  onClick={() => handleClick(index)}
                />
              ))}
            </div>
          ) : (
            <div className={cn("accordion-mobile", secondTabVariant)}>
              {accordionSecondary && accordionSecondary.map((item, index) => (
                <AccordionItemMobile
                  key={index}
                  step={index + 1}
                  title={item.title}
                  variant={secondTabVariant}
                  secondaryTitle={item.secondaryTitle}
                  content={item.content}
                  isOpen={openIndex === index}
                  onClick={() => handleClick(index)}
                />
              ))}
            </div>
          )
        : (
          <div className={cn("accordion-mobile", firstTabVariant)}>
            {accordion.map((item, index) => (
              <AccordionItemMobile
                key={index}
                step={index + 1}
                title={item.title}
                variant={firstTabVariant}
                secondaryTitle={item.secondaryTitle}
                content={item.content}
                isOpen={openIndex === index}
                onClick={() => handleClick(index)}
              />
            ))}
          </div>
        )}
    </div>
  );
};

export default AccordionMobile;
